import LoadingDots from '@Components/Common/LoadingDots';
import LoadingDotsVariant from '@Components/Common/LoadingDotsVariant';
import { Box } from '@mui/material';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';

const InfiniteScroll = React.forwardRef(
    (
        {
            children,
            ListComponent = React.Fragment,
            loadMore,
            hasMore = true,
            loading,
            ...props
        },
        ref,
    ) => {
        const { ref: inViewRef } = useInView({
            onChange: inView => inView && hasMore && loadMore(),
            triggerOnce: true,
            rootMargin: '0px 0px 0px 0px',
        });

        const childrenArray = React.Children.toArray(children);

        return (
            <>
                <ListComponent ref={ref} {...props}>
                    {childrenArray.map((child, index) => {
                        if (childrenArray.length === index + 1) {
                            return React.cloneElement(child, {
                                ref: inViewRef,
                            });
                        }
                        return child;
                    })}
                </ListComponent>
                {loading && (
                    <Box
                        width="100%"
                        display="flex"
                        justifyContent="center"
                        mt={3}
                    >
                        {/* <LoadingDots size={16} /> */}
                        <LoadingDotsVariant size={16} />
                    </Box>
                )}
            </>
        );
    },
);

export default InfiniteScroll;
